import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';

import rootReducer from '../reducers';

const persistConfig = {
  /**
   * The key in LS which the persist data lives.
   */
  key: 'root',
  /**
   * You can add reducers to this list below to persist them in LS.
   * Right now, we only need 'cart' information in LS.
   */
  whitelist: ['cart'],
  /**
   * Right now we are using localstorage for cart.
   */
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers = (
  process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
) || compose;

/**
 * Configures a store & returns the persister & store for
 * top level Provider to destructure.
 * @param {Object} preloadedState - The preloaded state (if any).
 * @returns {Object<store, persistor>} - The store & LS persistor for Provider.
 */
const configureStore = (preloadedState) => {
  const store = createStore(
    persistedReducer,
    preloadedState,
    composeEnhancers(applyMiddleware(thunk)),
  );

  return {
    store,
    persistor: persistStore(store),
  };
};

export default configureStore;
